import { DefaultButton } from "components/Shared/DefaultButton";

type Props = {
  isLoading: boolean;
  isAdd: boolean;
  onAdd: () => void;
  onDelete: () => void;
};

export const AddDeleteButton = ({ isLoading, isAdd, onAdd, onDelete }: Props) => {
  if (!isAdd) {
    return (
      <DefaultButton onClick={onDelete} loading={isLoading} type="default" icon={<i className="fa-solid fa-minus" />} />
    );
  }

  return <DefaultButton onClick={onAdd} loading={isLoading} type="default" icon={<i className="fa-solid fa-plus" />} />;
};
